import merge from "lodash/merge";

export const convertDottedPropsToObject = <T extends Record<string, unknown>>(o: T) => {
  const createObject = (fields: string[], value: unknown) => ({
    [fields[0]]: fields.length > 1 ? createObject(fields.slice(1), value) : value,
  });
  return Object.keys(o).reduce((res, key) => {
    if (key.includes(".")) {
      return merge(res, createObject(key.split("."), o[key]));
    }
    return { ...res, [key]: o[key] };
  }, {});
};
